import { render, staticRenderFns } from "./SubmissionResponse.vue?vue&type=template&id=66177530&scoped=true"
import script from "./SubmissionResponse.vue?vue&type=script&lang=js"
export * from "./SubmissionResponse.vue?vue&type=script&lang=js"
import style0 from "./SubmissionResponse.vue?vue&type=style&index=0&id=66177530&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66177530",
  null
  
)

export default component.exports